/** 
*@author: S Poornachandu
*@Description : 
**/
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import localStorage from "../../../utils/localStorage";
import StyledTable from "../../../commons/styles/table";
import { constant } from "../../Settings/Constants";
import { DrawerFooter } from "../../../commons/styles/layout";
import { API_DEVICE,IPAddress, API_PARAMETERHIERARCHY } from "../../../commons/api";
import {
  Form,
  Col,
  Input,
  Drawer,
  Button,
  Card,
  Row,
  message,
  Popconfirm,
  Upload,
  Select,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  UploadOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import { getAssetList, getDeviceList, getParametersList } from "./ChatCalls";

const { Option } = Select;

const NestedHierarchy = (props) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  // const location = useLocation();
  const nhRef = useRef(null);
  const deviceref = useRef(null);
  const [data,setData] = useState('');
  const [state, setState] = useState({
    visible: false,
    datasource: [],
    editObj: {},
    HierarchyName: "",
    ParentId: undefined,
    parentHierarchy: [],
    modalVisible: false,
    deviceList: [],
    selectedObject: {},
    value: [],
    translationCache: props.translationCache || [],
    devicesList: [],
    parentObject: null,
  });
const type =
  (nhRef.current && nhRef.current.getFieldsValue().Type) ||
  (state?.editObj?.Type);

  useEffect(() => {
    
    const pathSnippets = props.location.pathname
      .split("/rubus/settingsPage/ParameterHierarchy/")
      .filter((i) => i);
    if (pathSnippets && pathSnippets[0]) {
      let hierarchyLevel = pathSnippets[0].split("/")
      .filter((i) => i);
      let parentObject = props.location.state || null;
      let ParentId = parentObject && parentObject.Id ? parentObject.Id : null;

      _getHierarchyList(hierarchyLevel[0] || null, ParentId);
      setState(prev => ({
        ...prev,
        HierarchyName: hierarchyLevel,
        parentObject,
        ParentId,
      }));
    }
  }, []);
   useEffect(() => {
   handleDownload();
  }, [state.ParentId]);
  const _getHierarchyList = async (HierarchyName, ParentId) => {
    
      const accessToken = localStorage.get('accessToken');
      const siteId = localStorage.get('currentSite');
      let orgHeaders=({
        method: 'GET',
        url: `${API_PARAMETERHIERARCHY.GET}?SiteId=${siteId}&HierarchyName=${HierarchyName}&ParentId=${ParentId}`,
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      return axios (orgHeaders)
      .then((response) =>{
      if (Array.isArray(response.data)) {
        setState(prev => ({
          ...prev,
          datasource: response.data,
          HierarchyName,
          ParentId,
        }));
      }
     })
    .catch(function (error) {
          console.log(error);
        });
  };


  const openModal = () => {
    if (nhRef.current) {
      nhRef.current.resetFields();
    }

    setState((prevState) => ({
      ...prevState,
      visible: true,
      editObj: {},
    }));
  };

  const _cancel = () => {
    if (nhRef.current) {
      nhRef.current.resetFields();
    }
    setState((prevState) => ({
      ...prevState,
      visible: false,
      editObj: {},
    }));
  };

  // Edit Hierarchy
  const editHierarchy = async(editObj) => {
   
    if (nhRef.current) {
      nhRef.current.setFieldsValue(editObj);
    }
    let devicesList = {};
    if (editObj.Type === 'AssetParameter' || editObj.Type === 'Asset'){
      devicesList = await getAssetList();
    }else if(editObj.Type === 'Parameter'|| editObj.Type === 'Device'){
      devicesList = await getDeviceList();
    }
    setState((prevState) => ({
      ...prevState,
      devicesList:devicesList,
      editObj,
      visible: true,
    }));
  };

  // Create Hierarchy
  const _createHierarchy = (e) => {
    // const {  ParentId } = state;
    // const siteId = localStorage.get("currentSite");
    e.preventDefault();

    nhRef.current
      .validateFields()
      .then(async (values) => {
        const payload = {
          data :[{
          ...values,
          // HierarchyName:state.HierarchyName,
          // HierarchyType: values.Next && values.Next === true ? 0 : 1,
          // HierarchyId: HierarchyName,
          // ParentId,
          // SiteId: siteId,
        }]
      };
        _createHierarchyAPI(payload);
      })
      .catch(() => { });
  };

  // Create Hierarchy API Call
  const _createHierarchyAPI = (createObject) => {
    const { HierarchyName, parentObject } = state;
    const accessToken = localStorage.get("accessToken");
    const siteId = localStorage.get("currentSite");

    const orgCreateHeaders = {
      method: "POST",
      url: `${API_PARAMETERHIERARCHY.CREATE}?SiteId=${siteId}&ParentId=${state.ParentId}&ParentType=${state?.parentObject?.Type || null}&HierarchyCode=${state?.HierarchyName}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: createObject,
    };

    axios(orgCreateHeaders)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          message.success("Hierarchy Saved");
          _getHierarchyList(
            HierarchyName,
            parentObject && parentObject.Id ? parentObject.Id : null
          );
          setState((prevState) => ({
            ...prevState,
            visible: false,
          }));
        }
      })
      .catch((error) => {
        message.error(error.response.data.message);        
      });
  };

const handleDownload = async () =>{
    const siteId = localStorage.get('currentSite');
      const accessToken = localStorage.get('accessToken');
      let url = '';
      url = `${API_PARAMETERHIERARCHY.DOWNLOAD}?SiteId=${siteId}&HierarchyCode=${state.HierarchyName}&ParentId=${state.ParentId}`;
  
      let orgHeaders = {
        method: 'GET',
        url,
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      };
      return axios(orgHeaders)
        .then((response) => {
         setData(response.data.file);
        })
        .catch(function (error) {
          console.log(error);
        });
  };
  // Update Hierarchy
  const _updateHierarchy = (e) => {
    e.preventDefault();
    nhRef.current
      .validateFields()
      .then(async (values) => {
        delete values.CreatedDate;
        // delete values.Code;

        const updateObject = {
          ...values,
          
        };
        _updateHierarchyAPI(updateObject,state.editObj.Id);
      })
      .catch(() => { });
  };


  // Update Hierarchy API Call
  const _updateHierarchyAPI = (updateObject,Id) => {
    const { HierarchyName, editObj, parentObject } = state;
    const accessToken = localStorage.get("accessToken");
    const siteId = localStorage.get("currentSite");
    
    const orgUpdateHeaders = {
      method: "PATCH",
      url: `${API_PARAMETERHIERARCHY.UPDATE}?SiteId=${siteId}&Id=${Id}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: {
        HierarchyName:editObj.HierarchyName,
        ParentId:editObj.ParentId,
        ...updateObject,
      },
    };

    axios(orgUpdateHeaders)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          message.success("Hierarchy Updated");
          _getHierarchyList(
            HierarchyName,
            parentObject && parentObject.Id ? parentObject.Id : null
          );
          setState((prevState) => ({
            ...prevState,
            visible: false,
            editObj: {},
          }));
        }
      })
      .catch((error) => {
        message.error(error.response.data.message);
      });
  };

  // Delete Hierarchy
  const _deleteHierarchy = (payload) => {
    const { HierarchyName, parentObject } = state;
    const accessToken = localStorage.get("accessToken");
    const siteId = localStorage.get("currentSite");

    const orgDeleteHeaders = {
      method: "DELETE",
      url: `${API_PARAMETERHIERARCHY.DELETE}?SiteId=${siteId}&HierarchyCode=${HierarchyName}&ParentId=${parentObject.Id}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: payload,
    };

    axios(orgDeleteHeaders)
      .then((response) => {
        if (response.status === 200 || response.status === 204) {
          message.success("Hierarchy Deleted");
          _getHierarchyList(
            HierarchyName,
            parentObject && parentObject.Id ? parentObject.Id : null
          );
          setState((prevState) => ({
            ...prevState,
            visible: false,
          }));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Navigation to Next Level
  const nextLevel = (record) => {
    const { HierarchyName, parentHierarchy, ParentId } = state;

    _getHierarchyList(
      HierarchyName,
      record && record.Id ? record.Id : null
    );

    const updatedParentHierarchy = [...parentHierarchy, ParentId];

    navigate({
      pathname: `/rubus/settingsPage/ParameterHierarchy/${HierarchyName}/${record.Name}`,
    });

    setState((prevState) => ({
      ...prevState,
      parentObject: record,
      parentHierarchy: updatedParentHierarchy,
    }));
  };

  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword]
      ? translationCache[keyword]
      : keyword;
  };


  const handleChange = (info) => {
    const { status } = info.file;
    if (status === "done") {
      message.success(`${info.file.name} file uploaded successfully.`);
    } else if (status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  const beforeUpload = (file) => {
    const isLt10M = file.size / 1024 / 1024 < 10;
    const isCSV = file.type === 'text/csv' || file.name.endsWith('.csv');
      if (!isCSV) {
          message.error('You can only upload CSV files!');
      }
    if (!isCSV) {
      message.error("XLXS file must be smaller than 10MB!");
    }
    return isLt10M && isCSV;
  };

  const openDeviceModal = () => {
    deviceChange([]);
    const devicelist = _getDeviceList(state.parentObject);
    setState((prevState) => ({
      ...prevState,
      modalVisible: true,
      deviceList:devicelist,
      value:undefined

    }));
  };

  const _getDeviceList = (parentObject) => {
    const SiteId = localStorage.get("currentSite");
    let accessToken = localStorage.get("accessToken");
    const healthHeaders = {
      method: "GET",
      url: `${API_DEVICE.LIST}?SiteId=${SiteId}&ParentEquipment=${parentObject && parentObject.Type && parentObject.Type === "Device" ? parentObject && parentObject.Code ? parentObject.Code : null : null}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    };

    axios(healthHeaders)
      .then((response) => {
        setState((prevState) => ({
          ...prevState,
          deviceList: response.data
        }));
      })
      .catch(() => { });
  };

  const onOk = () => {
    setState((prevState) => ({
      ...prevState,
      modalVisible: false,
      value:[]
    }));
    deviceref?.current?.setFieldsValue({
      Device:null
    });
    _createHierarchyAPI(state.selectedObject);
  };

  const deviceChange = (value) => {
    const { deviceList } = state;

    let data = value.map((item) => {
      let innerObject = deviceList.find(selectedDevice => selectedDevice.Id === item);
      return innerObject ? {
        Name: innerObject.Name,
        Code: innerObject.DeviceCode,
        // ParentCode: parentObject && parentObject.Code ? parentObject.Code : null,
        Type: "Device",
      } : {};
    }).filter(item => Object.keys(item).length > 0);

    let payload = {
      data
    };
    setState((prevState) => ({
      ...prevState,
      selectedObject: payload, 
      value:[]
    }));
  };

  const _OnCancel = () => {
    if (nhRef.current) {
      nhRef.current.resetFields();
    }
    setState((prevState) => ({
      ...prevState,
      modalVisible: false,
      editObj: {},
      value:[]
    }));
    deviceref?.current?.setFieldsValue({
      Device:null
    });
  };

  const onFinishFailed = () => {
    message.error("please Input required fields");
  };

  const onTypeChange = async (value) => {
    let devicesList = {};
    if (value === 'AssetParameter'){
      devicesList = await getAssetList();
    }else if(value === 'Parameter'){
      devicesList = await getDeviceList();
    }
    setState((prevState) => ({
      ...prevState,
      Type: value,
      devicesList : devicesList

    }));
    nhRef?.current?.setFieldsValue({
      Code:null,
      ParentCode:null,
      Name:null,
    });
  };


  const columns = [
    {
      title: translation("Name"),
      dataIndex: "Name",
    },
    {
      title: translation("Code"),
      dataIndex: "Code",
    },
    {
      title: translation("Type"),
      dataIndex: "Type",
    },
    {
      title: translation("Action"),
      render: (text, record) =>(
        <div>
          <Button
            type="primary"
            onClick={() => editHierarchy(record)}
            style={{ marginRight: "10px" }}
          >
            <EditOutlined />
          </Button>

          {record && record.Default && record.Default !== true ? (
            <Popconfirm
              title={translation("Are you sure delete Hierarchy ?")}
              onConfirm={(e) => {
                e.stopPropagation();
                _deleteHierarchy(record);
              }}
              okText={translation(constant.yes)}
              cancelText={translation(constant.no)}
            >
              <Button type="prmiary">
                <span>
                  <DeleteOutlined />
                </span>
              </Button>
            </Popconfirm>
          ) : null}

          {(record.Type !== 'Parameter' && record.Type !=='AssetParameter') ? (
            <Button
              type="primary"
              onClick={() => nextLevel(record)}
              style={{ marginLeft: "10px" }}
            >
              {translation("Next Level")}
            </Button>
          ) : null}
        </div>
      )
    },
  ];
  const OnChangeParameter = async(value) =>{      
    const SiteId = localStorage.get("currentSite");
    let devicesList ={};
    let AssetCode = "AssetCode";
    let DeviceCode = "DeviceCode";
    let payload = { 
      [type === 'AssetParameter' ? AssetCode : DeviceCode]: [
          [ value]
      ],
      CodeType:type === 'AssetParameter' ? "Asset" : "Device",
      SiteId: SiteId,
      AliasCode:true
      };
     const deviceList = await getParametersList(payload) ;
     devicesList = Object.values(deviceList).flat();
     setState((prevState)=>({
      ...prevState,
      ParentCode:value,
      ParamterList:devicesList
     }));
      nhRef?.current?.setFieldsValue({
      Code:null,
    });
  };

  return (

    <div style={{ minHeight: window.innerHeight - 173 }}>
      <Drawer open={state.modalVisible} onClose={_OnCancel} closable>
        <Form ref={deviceref} layout="vertical">
        <Form.Item label={translation("Device")} name="Device"  >
          <Select
            mode="multiple"
            placeholder={translation("Please Select Equipment")}
            style={{ width: 350 }}
            // value={state.value}
            onChange={(value) => deviceChange(value)}
          >
            {state.deviceList &&
              Array.isArray(state.deviceList) &&
              state.deviceList.map((device, index) => (
                <Option key={index} value={device.Id}>
                  {device.DisplayCode}-{device.DeviceCode}
                </Option>
              ))}  
          </Select>
        </Form.Item>
        </Form>
        <DrawerFooter>
          <Button type="primary" shape="round" onClick={onOk}>
            {translation("Submit")}
          </Button>
        </DrawerFooter>
      </Drawer>
      <Card bordered={false}>
        <Drawer
          title={translation(!state.editObj.Id ? "Create Hierarchy" : "Update Hierarchy")}
          open={state.visible}
          width={600}
          closable
          onClose={_cancel}
        >
          <Form
            form={form}
            layout="vertical"
            name={"NestedHierarchyForm"}
            ref={nhRef}
            labelCol={{ span: 10 }}
            wrapperCol={{ span: 14 }}
            initialValues={state.editObj || {}}
            onFinishFailed={onFinishFailed}
          >
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item 
                  label={translation("Type")} 
                  name="Type"
                  rules={[
                    { required: true, message: translation("Please select a Type!") }
                  ]}
                >
                  <Select
                    placeholder={translation("Select Type")}
                    onChange={onTypeChange}
                  >
                    <>
                      <Option value="Asset">{translation("Asset")}</Option>
                      <Option value="AssetParameter">{translation("AssetParameter")}</Option>
                      <Option value="Device">{translation("Device")}</Option>
                      <Option value="Parameter">{translation("DeviceParameter")}</Option>
                    </>
                  </Select>
                </Form.Item>

                <Form.Item 
                  label={translation("Name")} 
                  name="Name" 
                  rules={[
                    { required: true, message: translation("Please input Name!") }
                  ]}
                >
                  <Input placeholder={translation("Input Name")} />
                </Form.Item>

                {type === 'Asset' || type === 'Device' ? (
                  <Form.Item 
                    label={
                      (type === "Device" && translation("Device Code")) ||
                      (type === "Asset" && translation("Asset Code"))
                    } 
                    name="Code"
                    rules={[
                      { required: true, message: 
                        (type === "Device" ? translation("Please input Device Code!") : translation("Please input Asset Code!")) }
                    ]}
                  >
                    <Input 
                      placeholder={
                        (type === "Device" && translation("Enter Device Code")) ||
                        (type === "Asset" && translation("Enter Asset Code"))
                      } 
                    />
                  </Form.Item>
                ) : (type === 'AssetParameter' || type === 'Parameter' ? (
                  <>
                    <Form.Item 
                      label={
                        (type === "Parameter" && translation("Device Code")) ||
                        (type === "AssetParameter" && translation("Asset Code"))
                      } 
                      name="ParentCode"
                      rules={[
                        { required: true, message: 
                          (type === "Parameter" ? translation("Please select Device Code!") : translation("Please select Asset Code!")) }
                      ]}
                    >
                      <Select 
                        placeholder={
                          (type === "Parameter" && translation("Select Device Code")) ||
                          (type === "AssetParameter" && translation("Select Asset Code"))
                        }
                        onChange={(value) => OnChangeParameter(value)}
                      >
                        {state.devicesList &&
                          Array.isArray(state.devicesList) &&
                          state.devicesList.map((device, key) => {
                            const Value = (type === "Parameter" ? device.DeviceCode : device.AssetCode);
                            return (
                              <Option key={key} value={Value}>
                                {translation(Value)}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>

                    <Form.Item 
                      label={
                        (type === "Parameter" && translation("DeviceParameter Code")) ||
                        (type === "AssetParameter" && translation("AssetParameter Code"))
                      } 
                      name="Code"
                      rules={[
                        { required: true, message: translation("Please select Parameter Code!") }
                      ]}
                    >
                      <Select 
                        placeholder={translation("Select Parameter Code")}
                      >
                        {state.ParamterList &&
                          Array.isArray(state.ParamterList) &&
                          state.ParamterList.map((device, key) => (
                            <Option key={key} value={device.ParameterCode}>
                              {translation(device.ParameterCode)}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </>
                ) : null)}


              </Col>
            </Row>
          </Form>
          <div style={{
            position: 'absolute',
            left: '0',
            bottom: '0',
            width: '100%',
            textAlign: 'center',
            paddingBottom: '10px'
          }}>
            <Button type="primary" onClick={_cancel} style={{ marginRight: 8 }}>
              {translation("Cancel")}
            </Button>
            {!state.editObj.Id ? (
              <Button type="primary" onClick={_createHierarchy}>
                {translation("Create")}
              </Button>
            ) : (
              <Button type="primary" onClick={_updateHierarchy}>
                {translation("Update")}
              </Button>
            )}
          </div>
        </Drawer>

        <Button
          type="primary"
          style={{ marginBottom: "10px", float: "right" }}
          onClick={openModal}
        >
          <PlusOutlined />
          {translation("Add")}{" "}
        </Button>

        <Button
          type="primary"
          style={{
            marginBottom: "10px",
            float: "right",
            marginRight: "10px",
          }}
          onClick={openDeviceModal}
        >
          {translation("Device Selection")}
        </Button>

        <Button
          type="primary"
          onClick={() => {
            props.navigate(-1);
          
            _getHierarchyList(
              state.HierarchyName,
              state && state.parentHierarchy[state.parentHierarchy.length - 1]
            );
            state.parentHierarchy.splice(-1, 1);
            setState((prevState) => ({
              ...prevState,
              parentHierarchy:state.parentHierarchy
            }));
          }}
        >
          {translation("Go back")}
        </Button>
       
        <Button
            type="primary"
            style={{
            marginBottom: "10px",
            float: "right",
            marginRight: "10px",
          }}
            >
              <a href={`${IPAddress.LOCAL}/api/downloads/configurations/${data}`}>
                <DownloadOutlined/>
               {translation('Download')}
              </a>
              
            </Button>

          <Button
            type="primary"
            style={{
            marginBottom: "10px",
            float: "right",
            marginRight: "10px",
          }}
            >
            <Upload
              name="file"
              action={`${API_PARAMETERHIERARCHY.UPLOAD}?SiteId=${localStorage.get("currentSite")}&HierarchyCode=${state?.HierarchyName}&ParentId=${state?.ParentId}&ParentType=${state?.parentObject?.Type || null}`}
              multiple={false}
              headers={{
                Authorization: `Bearer ${localStorage.get("accessToken")}`,
              }}
              beforeUpload={beforeUpload}
              onChange={handleChange}
              showUploadList={false}
            >
              <UploadOutlined/>
              {translation("Upload")}
            </Upload>
            </Button>
        <StyledTable size="small"
          columns={columns}
          dataSource={state && state.datasource ? state.datasource : []}
          pagination={
           state.datasource.length > 10
              ? {
                pageSize: "10",
              }
              : false
          }
        />
      </Card>
     
    </div>

  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(NestedHierarchy);